import React from 'react';

import ClassNames from 'classnames';
import {isNaN} from 'lodash';
import PropTypes from 'prop-types';

import {basicShouldComponentUpdate} from '@/libs/reactHelper';

import NumBox from '../numbox/NumBox';

import './InputSpinner.less';

class InputSpinner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const arrProps = ['step', 'value', 'minValue', 'readOnly', 'disabled', 'className'];
    const objProps = ['styleInput'];

    return basicShouldComponentUpdate(this.props, this.state, nextProps, nextState, arrProps, objProps, null);
  }

  onClickIncrease = () => {
    const {step, value, onClickIncrease, minValue, maxValue, onChange} = this.props;
    let val = parseFloat(value);
    if (isNaN(val)) {
      val = 0;
    }
    val += parseFloat(step);
    if (!isNaN(minValue) && minValue > val) val = minValue;
    if (!isNaN(maxValue) && maxValue < val) val = maxValue;
    onClickIncrease(val);
    this.setState({value: val});
    onChange(val);
  };

  onClickDecrease = () => {
    const {step, value, onClickDecrease, minValue, maxValue, onChange} = this.props;
    let val = parseFloat(value);
    if (isNaN(val)) {
      val = 0;
    }
    val -= parseFloat(step);
    // if (!isNaN(minValue) > val) val = minValue;
    // //if (!isNaN(maxValue) < val) val = maxValue;
    if (!isNaN(minValue) && minValue > val) val = minValue;
    if (!isNaN(maxValue) && maxValue < val) val = maxValue;
    onClickDecrease(val);
    this.setState({value: val});
    onChange(val);
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.value !== prevState.value) {
      return {
        value: nextProps.value,
      };
    }
    return null;
  }

  onChange = (newValue, e) => {
    const {onChange} = this.props;
    if (!onChange) return;

    onChange(newValue, e);
  };

  onClick = (newValue, e) => {
    const {onClick} = this.props;
    if (!onClick) return;

    onClick(newValue, e);
  };

  onBlur = (newValue) => {
    const {onBlur} = this.props;
    if (!onBlur) return;

    onBlur(newValue);
  };

  onKeyUp = (newValue) => {
    const {onKeyUp} = this.props;
    if (!onKeyUp) return;

    onKeyUp(newValue);
  };

  render() {
    const {
      label,
      unit,
      hideField,
      disabled,
      styleInput,
      placeholder,
      className,
      minValue,
      maxValue,
      fullWidthInput,
      readOnly,
    } = this.props;
    const {value} = this.state;
    const classLabelColumn = fullWidthInput ? 'col-md-4' : 'col-md-7';
    // eslint-disable-next-line no-nested-ternary
    const classInputCollumn = fullWidthInput
      ? unit === undefined
        ? 'col-md-9 '
        : 'col-md-8 '
      : unit === undefined
      ? 'col-md-6 '
      : 'col-md-5 ';
    return (
      <div className="middleAlign">
        <div className={classLabelColumn}>
          {!hideField && (
            <div className="row row-margin">
              <span
                className="spanStyleInputField"
                disabled={disabled}
              >
                {' '}
                {label}{' '}
              </span>
            </div>
          )}
        </div>
        <div className={classInputCollumn}>
          {!hideField && (
            <div className="middleAlign">
              <button
                className="btn btn-default glyphicon glyphicon-minus buttonSpinner dropdown-toggle"
                type="button"
                disabled={disabled || value === minValue}
                onClick={this.onClickDecrease}
              />
              <NumBox
                className={ClassNames('cmon-NumBoxSpin-input inputSpinner', className)}
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={this.onChange}
                onBlur={this.onBlur}
                onKeyUp={this.onKeyUp}
                readOnly={readOnly}
                style={styleInput}
                min={minValue}
                max={maxValue}
                disabled={disabled}
                onClick={this.onClick}
              />
              <button
                className="btn btn-default glyphicon glyphicon-plus buttonSpinner dropup-toggle"
                type="button"
                disabled={disabled || value === maxValue}
                onClick={this.onClickIncrease}
              />
            </div>
          )}
        </div>
        {unit !== undefined && (
          <div className="col-md-1">{!hideField && <span className="spanStyleInputField unit"> {unit} </span>}</div>
        )}
      </div>
    );
  }
}

InputSpinner.propTypes = {
  styleInput: PropTypes.object,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onClickIncrease: PropTypes.func,
  onClickDecrease: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyUp: PropTypes.func,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  step: PropTypes.number,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  onClick: PropTypes.func,
  label: PropTypes.string,
  unit: PropTypes.string,
  hideField: PropTypes.bool,
  fullWidthInput: PropTypes.bool,
};

InputSpinner.defaultProps = {
  onClickIncrease: () => {},
  onBlur: () => {},
  onKeyUp: () => {},
  onClickDecrease: () => {},
  onChange: () => {},
  styleInput: {},
  value: '',
  placeholder: 'Not set',
  className: '',
  step: 1,
  minValue: null,
  maxValue: null,
  readOnly: false,
  disabled: false,
  onClick: () => {},
  label: '',
  unit: '',
  hideField: false,
  fullWidthInput: false,
};

export default InputSpinner;
